"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var colors = {
  'reset': '\x1B[0m',
  'underline': '\x1B[4m',
  'red': '\x1B[31m',
  'yellow': '\x1B[33m',
  'blue': '\x1B[34m',
  'magenta': '\x1B[35m',
  'cyan': '\x1B[36m'
};
var _default = colors;
exports.default = _default;